import React, { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import {
  Loader,
  Header,
  Button,
  Label,
  Input,
  FieldGroup,
  Text,
  Fields,
} from '@pet-notify/ui'

import { usePetByIntellitag } from 'hooks/pets'
import useDocumentTitle from 'hooks/document-title'
import ErrorMessage from 'components/ErrorMessage'

const schema = yup.object().shape({
  confirmNumber: yup
    .string()
    .required('Confirm pet ID is required')
    .oneOf([yup.ref('number'), null], 'Must match pet id'),
})

type FormData = {
  number: string
  confirmNumber: string
}

function LookupPage() {
  useDocumentTitle('Found a lost pet? | Pet Notify')
  const [number, setNumber] = useState<string>()
  const navigate = useNavigate()
  const petQuery = usePetByIntellitag(number)
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>({
    resolver: yupResolver(schema),
  })

  const onSubmit = handleSubmit(({ number }) => {
    setNumber(number)
  })

  useEffect(() => {
    if (petQuery.data) {
      navigate(`/found/${number}`)
    }
  }, [petQuery.data])

  // useEffect(() => {
  //   if (navigator.geolocation) {
  //     navigator.geolocation.getCurrentPosition(
  //       (position) => {
  //         const latitude = position.coords.latitude;
  //         const longitude = position.coords.longitude;
  //         console.log(`Latitude: ${latitude}, Longitude: ${longitude}, Timestamp: ${position.timestamp}`);
  //       },
  //       (error) => {
  //         console.error(`Error Code = ${error.code} - ${error.message}`);
  //       }
  //     );
  //   } else {
  //     console.log("Geolocation is not supported by this browser.");
  //   }    
  // }, [])  

  if (number && petQuery.isLoading) {
    return <Loader />
  }

  return (
    <>
      <Header as='h1' size='xlarge' mb='6'>
        Found a lost pet? Let&apos;s get them reunited with their pet parent!
      </Header>

      <form onSubmit={onSubmit}>
        <Fields>
          <FieldGroup>
            <Label htmlFor='number'>Pet ID</Label>
            <Input
              id='number'
              placeholder="The pet's ID is an 8 digit number on the back of their Intellitag"
              type='text'
              {...register('number')}
            />
          </FieldGroup>

          <FieldGroup>
            <Label htmlFor='number'>Confirm pet ID</Label>
            <Input
              id='confirmNumber'
              type='text'
              {...register('confirmNumber')}
            />
          </FieldGroup>
        </Fields>

        {errors.confirmNumber && (
          <Text variant='error' mb='3'>
            {errors.confirmNumber.message}
          </Text>
        )}

        {petQuery.isError && <ErrorMessage error={petQuery.error} />}

        <Button type='submit'>Continue</Button>
      </form>
    </>
  )
}
export default LookupPage
